import { notificationTypes } from '../actions/types';

const initialState = {
  show: false,
  message: '',
  severity: 'error',
  autoHideDuration: null
}

export const notificationReducer = 
  ( 
    state = initialState, 
    action
  ) => {
    switch (action.type) {
      case notificationTypes.SHOW:
        return {
          ...state,
          ...action.payload,
          show: true,
        };
      case notificationTypes.HIDE:
        return {
          ...state,
          show: false,
        };
      default:
        return state;
    }
  };